import type { Notification } from '@repo/types/types/notification'
import { Button } from '@repo/ui/components/ui/button'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useNotificationCore } from '@/hooks/useNotificationCore'

interface NotificationMinimalProps {
  notification: Notification
  onMarkAsRead?: (id: string) => void
  showMarkAsRead?: boolean
  className?: string
}

export function NotificationMinimal({
  notification,
  onMarkAsRead,
  showMarkAsRead = true,
  className
}: NotificationMinimalProps) {
  const { isUnread, formattedTimestamp, handleMarkAsReadWithEvent } = useNotificationCore(notification, onMarkAsRead)

  return (
    <div className={cn('flex flex-col items-start gap-1 p-3', className)}>
      <div className="flex items-start justify-between w-full gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-sm font-medium leading-none">{notification.title}</p>
            {isUnread && (
              <div className="h-2 w-2 flex-shrink-0 rounded-full bg-primary" />
            )}
          </div>
          <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
            {notification.message}
          </p>
        </div>
        {showMarkAsRead && isUnread && onMarkAsRead && (
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 flex-shrink-0"
            onClick={handleMarkAsReadWithEvent}
          >
            <Check className="h-3 w-3" />
          </Button>
        )}
      </div>
      <p className="text-xs text-muted-foreground">
        {formattedTimestamp}
      </p>
    </div>
  )
}
